import RoleSelect from '../components/signup/RoleSelect';
import { useUser } from '../utils/UserContext';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  safeGetItem,
  safeSessionGetItem,
  safeSessionRemoveItem,
  safeSetItem,
} from '../shared/safeStorage';

function RoleSelectPage() {
  // Don't use useAuthRouter here to avoid circular dependency
  // Just use UserContext directly
  const { userRecord, isLoadingUser } = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  // Extract and store tachref if present in URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tachref = searchParams.get('tachref');
    if (tachref) {
      safeSetItem('tachref', tachref);
    }
  }, [location]);

  // If user record loads and user is active, redirect to saved path or dashboard
  useEffect(() => {
    if (!isLoadingUser && userRecord) {
      if (
        userRecord.status === 'active' ||
        userRecord.status === 'pre_active'
      ) {
        // Only active users can use deep links
        const searchParams = new URLSearchParams(location.search);
        const returnToParam = searchParams.get('returnTo');
        const redirectPath =
          returnToParam || safeSessionGetItem('redirectPath');

        if (
          redirectPath &&
          !redirectPath.includes('/role') &&
          !redirectPath.includes('/login') &&
          !redirectPath.includes('signup')
        ) {
          safeSessionRemoveItem('redirectPath');
          navigate(redirectPath);
        } else {
          navigate('/dashboard/home');
        }
      } else if (userRecord.status === 'pending') {
        // Pending users must complete signup first
        safeSessionRemoveItem('redirectPath'); // Clear any deep link
        // Preserve tachref when navigating to signup
        const tachref = safeGetItem('tachref');
        const signupUrl = tachref
          ? `/signup?tachref=${encodeURIComponent(tachref)}`
          : '/signup';
        navigate(signupUrl);
      } else if (!userRecord) {
        return;
      }
    }
  }, [userRecord, isLoadingUser, navigate, location]);

  // Show loading while user data is being fetched OR while we're about to redirect
  // Don't render RoleSelect if user will be redirected (active/pre_active/pending users)
  if (
    isLoadingUser ||
    (userRecord &&
      (userRecord.status === 'active' ||
        userRecord.status === 'pre_active' ||
        userRecord.status === 'pending'))
  ) {
    return (
      <div className="z-40 flex h-[100vh] w-[100vw] flex-col items-center justify-center align-middle">
        <img
          alt="loading-icon"
          src="/Icon-v2.gif"
          className="flex h-44 w-44 justify-center"
        />
        <h2 className="text-[14px] text-secondary">Loading...</h2>
      </div>
    );
  }

  // Only show role selection if user doesn't have a record or needs to complete signup
  return (
    <div
      className={`flex min-h-screen w-full flex-col items-center justify-start align-middle`}
    >
      <RoleSelect />
    </div>
  );
}

export default RoleSelectPage;
